import { IconProps } from 'src/utils/icon';

const BookLightIcon: React.FC<IconProps> = ({ size = 1 }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    fill="none"
    viewBox="0 0 43 43"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.625 16.127c-.059 0-.117.001-.173.004-4.182.238-11.8 1.092-16.951 3.995-5.15-2.903-12.77-3.757-16.952-3.995a2.885 2.885 0 00-.173-.004C2.663 16.126 0 17.33 0 20.343v14.953c0 2.242 1.785 4.09 4.06 4.21 2.89.151 10.125.762 14.865 3.146.393.2.811.294 1.231.323v.023h.19l.023.002h2.262l.022-.002h.19v-.023a3.19 3.19 0 001.232-.323c4.74-2.384 11.975-2.994 14.865-3.147 2.275-.119 4.06-1.968 4.06-4.209V20.343c0-3.012-2.663-4.216-4.375-4.216zm-18.469 24.13c-.007-.002-.015 0-.023-.005-5.005-2.517-12.13-3.23-15.932-3.43-.848-.044-1.513-.715-1.513-1.526V20.343c0-.508.148-.84.498-1.109.375-.289.879-.42 1.209-.42 3.108.177 10.857.888 15.761 3.64v17.804zm20.157-4.96c0 .81-.666 1.48-1.515 1.525-3.802.2-10.927.912-15.937 3.433-.006.003-.011.001-.018.004V22.455c4.904-2.754 12.653-3.464 15.748-3.64l.033-.002c.016 0 1.687.042 1.687 1.53v14.953h.002zM21.5 16.123A8.062 8.062 0 1021.5 0a8.062 8.062 0 000 16.124zm0-13.436a5.381 5.381 0 015.375 5.374 5.381 5.381 0 01-5.375 5.376 5.381 5.381 0 01-5.375-5.376A5.381 5.381 0 0121.5 2.689z"
      fill="#2c2a29"
    />
  </svg>
);

export default BookLightIcon;
